<ftr-side-nav-shell
  [displayMode]="displayMode"
  [expanded]="expanded"
  [isLoading]="isLoading"
  [currentCourtSystemId]="currentCourtSystemId"
  [isOpened]="isOpened"
  [navGroups]="navGroups()"
  [footerItems]="footerItems()"
  theme="dark"
  [disableBorder]="true"
  [helpMenuConfig]="{ mode: 'courts', courtSystemId: currentCourtSystemId }"
  (sideBarToggled)="sideBarToggled.emit()"
  (expandedToggled)="expandedToggled.emit()"
>
  <ftr-court-system-dropdown
    sideNavHeader
    [style.width]="'100%'"
    [currentCourtSystemId]="currentCourtSystemId"
    [collapsed]="!expanded"
    [displayMode]="displayMode"
    (dropdownOpened)="onCourtSystemDropdownOpened($event)"
  />
</ftr-side-nav-shell>
